/** Authorization scopes for grantless Selling Partner API operations. */
export enum AuthorizationScope {
  /** Scope for the Notifications API. */
  NOTIFICATIONS = 'sellingpartnerapi::notifications',
  /** Scope for rotating application client credentials. */
  CLIENT_CREDENTIAL_ROTATION = 'sellingpartnerapi::client_credential:rotation',
}
